<div class="spinner-container">
  <div class="contatori">
    @if (isLoading) {
      <div class="blur-background"></div>
      <mat-spinner [diameter]="25"></mat-spinner>
    }

    @for (totali of totaliCruscotto; track $index) {
      @if (!totali.nascondi) {
        <ng-container
          [ngTemplateOutlet]="totaliTemplate"
          [ngTemplateOutletContext]="{
            totali: totali,
          }"
        ></ng-container>
      }
    }
  </div>
</div>

<ng-template #totaliTemplate let-totali="totali">
  <div style="text-align: center">
    <div class="titolo-cont">{{ totali.titolo }}</div>
    <div class="contatore">
      @for (tot of totali.totaliPerElemento; track $index) {
        @if ($index > 0) {
          <div class="verticale"></div>
        }
        <div class="dato">
          <div class="valore" [style.color]="tot.color">
            {{ tot.valore }}
          </div>
          <div class="label">{{ tot.label }}</div>
        </div>
      }
    </div>
  </div>
</ng-template>
